import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"color":_vm.$app.opts.modalHeaderColor,"value":true,"max-width":_vm.$app.opts.modalSizeDefault,"persistent":"","scrollable":""},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"]))return null;return _vm.dismiss.apply(null, arguments)},"input":(v) => v || _vm.dismiss()}},[_c('contact-card',{attrs:{"dismiss":_vm.dismiss}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }